module.exports = __webpack_public_path__ + "static/media/pic5.ed15d2fc.jpeg";